import { Suspense, lazy } from 'react';
import Placeholder from 'react-bootstrap/Placeholder';
import Auth, { GuastLoader } from '../auth/Auth';
import http from '../common/services/HttpService';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import Navigation from './Navigation';

const Loadable = (Component: any) => (props: JSX.IntrinsicAttributes) =>
  (
    <Suspense fallback={<Placeholder />}>
      <Component {...props} />
    </Suspense>
  );
const Signin = Loadable(lazy(() => import('../auth/Signin')));
const Signup = Loadable(lazy(() => import('../auth/Signup')));
const ForgetPassword = Loadable(lazy(() => import('../auth/ForgetPassword')));
const ResetPassword = Loadable(lazy(() => import('../auth/ResetPassword')));
//Missions
const Mission = Loadable(lazy(() => import('../admin/missions/MissionList')));
const CreateEditMission = Loadable(lazy(() => import('../admin/missions/CreateEditMission')));
const MissionView = Loadable(lazy(() => import('../admin/missions/MissionView')));
const Leaderboard = Loadable(lazy(() => import('../admin/leaderboard')));


//Tasks
const TaskList = Loadable(lazy(() => import('../admin/tasks/TaskList')));
const TaskView = Loadable(lazy(() => import('../admin/tasks/TaskView')));
const CreateEditTask = Loadable(lazy(() => import('../admin/tasks/CreateEditTask')));
//Users
const UserList = Loadable(lazy(() => import('../admin/users/UserList')));
//Reward
const RewardList = Loadable(lazy(() => import('../admin/rewards/RewardList')));
const CreateEditReward = Loadable(lazy(() => import('../admin/rewards/CreateEditReward')));
//Backgrounds
const BackgroundList = Loadable(lazy(() => import('../admin/backgrounds/BackgroundList')));
const CreateEditBackground = Loadable(lazy(() => import('../admin/backgrounds/CreateEditBackground')));
//Learn Content
const LearnContentList = Loadable(lazy(() => import('../admin/learn-content/LearnContentList')));
const CreateEditLearnContent = Loadable(lazy(() => import('../admin/learn-content/CreateEditLearnContent')));

//Submissions
const SubmissionsPage = Loadable(lazy(() => import('../admin/submissions/SubmissionsPage')));

const PrivacyPolicy = Loadable(lazy(() => import('../admin/PrivacyPolicy')));
const NotFound = Loadable(lazy(() => import('../common/components/NotFound')));


const routes = createBrowserRouter([
  {
    path: '/auth',
    element: <Auth />,
    loader: GuastLoader,
    errorElement: <Navigate to={'/'}/>,
    children: [
      {
        path: 'signin',
        element: <Signin />
      },
      {
        path: 'register',
        element: <Signup />
      },
      {
        path: 'forgetpassword',
        element: <ForgetPassword />
      },
      {
        path: 'resetpassword/:authKey',
        element: <ResetPassword />
      },
      {
        path: '',
        element: <Navigate to={'/auth/signin'} replace={true}/>,
      },
    ],
  },
  {
    path: '',
    element: <Navigation />,
    loader: async () =>{
      return http.get('/users/me?isWeb=true');
    },
    errorElement: <Navigate to={'/auth/signin'}/>,
    shouldRevalidate: () => false,
    children: [
      {
        path: '',
        element: <Navigate to={'/missions'}/>,
      },
      {
        path: 'missions',
        children: [
          {
            index: true,
            element: <Mission />
          },
          {
            path: 'new',
            element: <CreateEditMission />
          },
          {
            path: 'edit/:id',
            element: <CreateEditMission />,
          },
          {
            path: ':id',
            element: <MissionView />,
            children: [
              {
                index: true,
                element: <TaskList />,
              },
              {
                path: 'leaderboard',
                element: <Leaderboard />,
              }
            ]
          }
        ]
      },
      {
        path: 'tasks',
        children: [
          {
            path: 'new',
            element: <CreateEditTask />
          },
          {
            path: 'edit/:id',
            element: <CreateEditTask />
          },
          {
            path: ':id',
            element: <TaskView />
          }
        ]
      },
      {
        path: 'rewards',
        children: [
          {
            index: true,
            element: <RewardList />
          },
          {
            path: 'new',
            element: <CreateEditReward />
          },
          {
            path: 'edit/:id',
            element: <CreateEditReward />,
          }
        ]
      },
      {
        path: 'backgrounds',
        children: [
          {
            index: true,
            element: <BackgroundList />
          },
          {
            path: 'new',
            element: <CreateEditBackground />
          },
          {
            path: 'edit/:id',
            element: <CreateEditBackground />,
          }
        ]
      },
      {
        path: 'learn-content',
        children: [
          {
            index: true,
            element: <LearnContentList />
          },
          {
            path: 'new',
            element: <CreateEditLearnContent />
          },
          {
            path: 'edit/:id',
            element: <CreateEditLearnContent />,
          }
        ]
      },
      {
        path: 'users',
        element: <UserList />
      },
      {
        path: 'submissions',
        element: <SubmissionsPage />
      },
    ],
  },
  {
    path: 'privacypolicy',
    element: <PrivacyPolicy />
  },
  {
    path: '*',
    element: <NotFound />
  },
]);

export default routes;
